import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBullhorn, faCircleQuestion, faDownload } from "@fortawesome/free-solid-svg-icons";
import GoogleTranslate from '../Assets/google-translate/GoogleTranslate';

const Footer = () => {
    const downloadCSV = (fileName) => {
        const link = document.createElement("a");
        if (fileName === "Sample_SOP_CSV.csv") {
            link.href = "/files/Sample_SOP_CSV.csv";
        } else if (fileName === "Sample_KPI_CSV.csv") {
            link.href = "/files/Sample_KPI_CSV.csv";
        }
        link.download = fileName;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const location = useLocation();


    // BUG-68: zIndex lowered from 9999 → 30 so modals/drawers (1050+) overlay correctly.
    return (
        <footer className={`Footer ${location.pathname === '/' ? ' d-none' : ''}`} style={{ backgroundColor: '#1f8a24', minHeight: '35px', height: 'auto', position: 'fixed', bottom: 0, width: '100%', zIndex: 30 }}>
            <div className="footer-content">
                <p className='notranslate ms-3 mb-0 align-self-center' translate="no" style={{ fontSize: '0.8rem' }}>Powered by PBOPlus Consulting services</p>
                <div className="footer-icons">
                    {/* <div id="google_translate_element" className='pt-2'></div> */}
                    <GoogleTranslate />

                    <div className="d-none d-md-flex align-items-center">
                        <div>  <Link to="" >
                            <FontAwesomeIcon icon={faBullhorn} />
                            <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger ft-5">1</span>
                        </Link></div>
                        <div>   <Link to="">
                            <FontAwesomeIcon icon={faCircleQuestion} />
                        </Link></div>
                        <div className="dropdown mx-3">
                            <FontAwesomeIcon icon={faDownload} className="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false" />
                            <ul className="dropdown-menu p-1 ft-9" style={{ minWidth: '5rem' }}>
                                <li>
                                    <button
                                        type="button"
                                        className="dropdown-item"
                                        onClick={() => downloadCSV("Sample_SOP_CSV.csv")}
                                    >
                                        3T SOP
                                    </button>
                                </li>
                                <li>
                                    <button
                                        type="button"
                                        className="dropdown-item"
                                        onClick={() => downloadCSV("Sample_KPI_CSV.csv")}
                                    >
                                        KPI
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

        </footer >
    );
}


export default Footer;